import service from '@/request/http.js'
 
 
 
export const logins = (data) => {
    return service({
        url: '/user/LoginOn',
        method: 'post',
        data
    })
};
 
export const SchoolGetRegSchoolList = data => {
    return service({
        url: '/School/GetRegSchoolList',
        method: 'get'
    })
};
 
export const test = () => {
    return service({
        url: '/index/test',
        method: 'get'
    })
};
 
export const register = (data) => {
    return service({
        url: '/user/Register',
        method: 'post',
        data
    })
};
 
export const changeemial = (data) => {
    return service({
        url: '/user/EmailIsExists?ui_email='+data,
        method: 'get',
    })
};